/** Compact label for a project member (bettor) in leaderboards — first name only. */
export function bettorDisplayName(name) {
  if (name == null) return "";
  const trimmed = String(name).trim();
  if (!trimmed) return "";
  const first = trimmed.split(/\s+/)[0];
  return first || trimmed;
}
